// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"18":"49a82a5367343c56","484":"cca4dcb88065c9ce","497":"2d0fcbfd9cee3afa","679":"306d9a5ef246664d"}[chunkId] + ".js";
};